<template>
  <div
  v-if="list.length"
  :style="{paddingTop: pxToRem(paddingTop), paddingBottom: pxToRem(paddingBottom)}">
    <div :style="{ width: pxToRem(width), margin: '0 auto' }">
    <van-swipe :autoplay="autoplay" indicator-color="#C13C33" :stop-propagation="false">
      <van-swipe-item v-for="(item) in list" :key="item.id">
        <div class="img-box" @click="jumpTo(item)" :style="{ height: pxToRem(height)}">
          <img class="index-index-image" :src="item.imageUrl+'?x-oss-process=style/style_index_banner'"/>
        </div>
      </van-swipe-item>
    </van-swipe>
  </div>
  </div>
</template>

<script>
import http from "@/utils/axios";
import utils from "@/utils/common";
import { isWeChatApplet } from "@/utils/util";
export default {
  props: {
    code: String, //广告位编码
    groupCode: String, //广告位组编码
    refreshing: Boolean, //监听页面下拉刷新
    paddingTop: {
      type: [Number, String],
      default: 0
    },
    paddingBottom: {
      type: [Number, String],
      default: 0
    },
    width: {
      type: [Number, String],
      default: 690
    },
    height: {
      type: [Number, String],
      default: 180
    },
    autoplay:{
      default:7000,
      type:[Number,String]
    }
  },
  data() {
    return {
      list: []
    }
  },
  watch: {
    refreshing(newVal) {
      if(!newVal) {
        this.getAdData()
      }
    }
  },
  mounted() {
    this.getAdData()
  },
  methods: {
    pxToRem(value) {
      return Number(value) * 0.01333 + 'rem'
    },
    getAdData() {
      http({
        url: '/order/app/ad-position/getAdContent',
        method: 'POST',
        parmes: {
          adPositionCode: this.code,
          adPositionGroupCode: this.groupCode
        }
      }).then(({ data }) => {
        //resultStatus 1广告位不存在，2广告位不生效，3没有广告,4有广告 
        if(data.resultStatus == 4 && (data = data.adContentVO)) {
          this.list = data.itemList
        }
      })
    },
    async jumpTo({ linkType, linkValue, adContentId }) {
      //记录点击量
      http({
        url: '/order/app/ad-position/handlerAdContentTrigger',
        method: 'post',
        parmes: {
          adContentId: adContentId,
          triggerType: 'ONCLICK_001'
        }
      })

      let url, miniUrl,action={}, noTitle='0',obj={};
      switch (linkType){
        case 1: //不跳转
          return;
        case 2: //活动链接
          url = linkValue
          miniUrl = '/others/pages/navigate-webview/index?webtype=iconsDetail&weburl=' + encodeURIComponent(linkValue)
          break;
        case 3: //商品详情
          url = location.origin + '/h5user/commoditydetails?id=' + linkValue
          miniUrl = '/product/pages/product-detail/index?productid=' + linkValue
          obj = {goodsId:parseInt(linkValue)}
          action = {tm:"4030100",tp:obj}
          break;
        case 4: //店铺
          url = location.origin + '/h5user/brandIndex?id=' + linkValue
          miniUrl = '/product/pages/store-detail/index?storeid=' + linkValue
          noTitle='1';
          obj = {branchId:parseInt(linkValue)}
          action = {tm:"4090100",tp:obj}
          break;
        case 5: //话题详情
          url = location.origin + '/h5user/discoverHottopic?hotId=' + linkValue
          miniUrl = '/others/pages/navigate-webview/index?webtype=topicDetail&subjectId=' + linkValue
          break;
        case 6: //发现详情
          url = location.origin + '/h5user/discoverUserDetails?id=' + linkValue
          miniUrl = '/others/pages/find-details/index?discoverId=' + linkValue
          noTitle='1';
          break;
      }
      if(await isWeChatApplet()) {
        utils.jumpToNewPage({ url, noTitle,action })
      } else {
        wx.miniProgram.navigateTo({ url: miniUrl,action })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.index-index-image{
  display: block;
  width: 100%;
}
</style>
